import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import ButtonBasic from '../../atoms/buttonBasic/view';
import ButtonLoading from '../../atoms/buttonLoading/view';
import './style.css';

/**
 * OfflineClientFormModal Organism
 * Form to create an offline client for the accountant.
 */
function OfflineClientFormModal({ onSubmit, onClose, isLoading }) {
    const [formData, setFormData] = useState({
        name: '',
        companyName: '',
        email: '',
        document: '',
        document_type: 31, // Default NIT in Colombia
        phone: '',
        address: ''
    });

    const [validated, setValidated] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'document_type' ? Number(value) : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }

        // Clean up empty optional fields
        const payload = {};
        Object.keys(formData).forEach(key => {
            const val = formData[key];
            if (val !== '' && val !== null && val !== undefined) {
                payload[key] = val;
            }
        });

        onSubmit(payload);
    };

    return (
        <div className="offline-client-form-container">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <h3 className="offline-client-form-title">Registrar Nuevo Cliente</h3>
                <p className="offline-client-form-description">
                    Ingresa la información básica del cliente. Se creará una empresa/usuario y se asociará a tu perfil automáticamente.
                </p>

                <Row >
                    <Form.Group controlId="offline-client-name" className="mb-3 mb-md-0">
                        <Form.Label>Nombre Completo / Representante <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            required
                            type="text"
                            placeholder="Ej. Juan Pérez"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            El nombre del representante es obligatorio.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="offline-client-companyName">
                        <Form.Label>Razón Social / Nombre Empresa <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            required
                            type="text"
                            placeholder="Ej. Creatives 3D S.A.S"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            El nombre de la empresa es obligatorio.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>

                <Row>
                    <Form.Group controlId="offline-client-document-type" className="mb-3 mb-md-0">
                        <Form.Label>Tipo de Identificación</Form.Label>
                        <Form.Select
                            name="document_type"
                            value={formData.document_type}
                            onChange={handleChange}
                        >
                            <option value={31}>NIT (Número de Identificación Tributaria)</option>
                            <option value={13}>Cédula de Ciudadanía</option>
                            <option value={22}>Cédula de Extranjería</option>
                            <option value={41}>Pasaporte</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group controlId="offline-client-document">
                        <Form.Label>Número de Documento / NIT</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ej. 901234567-8"
                            name="document"
                            value={formData.document}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Row>

                <Row>
                    <Form.Group controlId="offline-client-email" className="mb-3 mb-md-0">
                        <Form.Label>Correo Electrónico</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Ej. cliente@empresa.com"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            Por favor ingresa un correo electrónico válido.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="offline-client-phone">
                        <Form.Label>Teléfono / Celular</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ej. 3001234567"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Row>

                <Form.Group className="mb-4" controlId="offline-client-address">
                    <Form.Label>Dirección</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Ej. Calle 100 # 15-22, Bogotá"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                    />
                </Form.Group>

                <div className="offline-client-btn-group">
                    <ButtonBasic
                        title="Cancelar"
                        onClick={onClose}
                        disabled={isLoading}
                        type="button"
                    />
                    <ButtonLoading
                        id="register-offline-client"
                        title={isLoading ? "Registrando..." : "Registrar Cliente"}
                        type="submit"
                        disabled={isLoading}
                    />
                </div>
            </Form>
        </div>
    );
}

export default OfflineClientFormModal;
